const Cow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
      <path
        data-name="Caminho 12853"
        d="M19 3h-4.18a2.988 2.988 0 0 0-5.64 0H5a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V5a2.006 2.006 0 0 0-2-2zm-7 0a1 1 0 1 1-1 1 1 1 0 0 1 1-1zm-2 14-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9z"
        transform="translate(-3 -1)"
      />
    </svg>
  );
};

export default Cow;
